import { NoDistrictRouteGuard } from '../../guards/no-district-route-guard/no-district-route-guard';

export const shelterPickerRoute = {
  path: 'shelter-picker',
  url: '/shelter-picker',
  canActivate: [NoDistrictRouteGuard],
  loadChildren: () => import('../../../shell/shelter-picker/shelter-picker.module').then(m => m.ShelterPickerModule),
};
